import { Chip, type SxProps, type Theme } from "@mui/material";
import type { FC } from "react";

type Props = {
	label: string;
	sx?: SxProps<Theme>;
	dataTestId?: string;
};

/** Small MUI BETA badge in the theme's primary color, for tagging in-progress features. */
export const BetaBadge: FC<Props> = ({ label, sx, dataTestId }) => (
	<Chip
		label={label}
		size="small"
		color="primary"
		data-testid={dataTestId}
		sx={{ height: 18, fontSize: "10px", fontWeight: 700, letterSpacing: "0.5px", "& .MuiChip-label": { px: 0.75 }, ...sx }}
	/>
);
